import React, { Component, Fragment, useState, useEffect } from 'react';
import { translate } from '../Services/translation';
import { getVATStatus } from '../Services/VAT.service';

const ToggleVAT = () => {
    const [VATstatus, setVATStatus] = useState(false);    

    const toggleVAT = (e) => {
        setVATStatus(e.target.checked);
        document.cookie = `IncludeVat=${e.target.checked}; path=/; max-age=2592000; SameSite=Lax`;
        location.href = location.href;
    }

    useEffect(() => {        
        setVATStatus(getVATStatus());        
    }, []);

    return <Fragment>
        <div className="vat-toggle-container">
            <label className="switch">
                <input type="checkbox" onChange={(e) => toggleVAT(e)} checked={VATstatus}/>
                <span className="slider"></span>
            </label>
            <span>{VATstatus ? translate('header.vattoggle.includingvat') : translate('header.vattoggle.excludingvat')}</span>            
        </div>
    </Fragment>
}

export default ToggleVAT;